export class EvaluationRetriever {
  constructor(bffEvaluationClient) {
    this.bffEvaluationClient = bffEvaluationClient;
  }

  async getLastEvaluation(idNumber) {
    try {
      const evaluations = await this.bffEvaluationClient.getEvaluations(idNumber);
      return evaluations.data[0];
    } catch (_error) {
      throw new Error(`No se pudo obtener la evaluación ${_error.message}`);
    }
  }

  async getEvaluationData(evaluationId) {
    const evaluationData = await this.bffEvaluationClient.getGeneral(evaluationId);
    return evaluationData.data;
  }

  async getDebtorData(idNumber) {
    const debtorInfo = await this.bffEvaluationClient.getDebtor(idNumber);
    return debtorInfo.data;
  }

  async getSimulationData(evaluationId, type) {
    const simulationData = await this.bffEvaluationClient.getSimulation(evaluationId, type);
    return simulationData.data;
  }

  async getEvaluations(idNumber) {
    try {
      const evaluations = await this.bffEvaluationClient.getEvaluations(idNumber);
      return evaluations.data;
    } catch (_error) {
      throw new Error(`No se pudo obtener las evaluaciones ${_error.message}`);
    }
  }

  async getEvidence(evaluationId) {
    try {
      const evidence = await this.bffEvaluationClient.getEvidence(evaluationId);
      return evidence.verificationLetter;
    } catch (_error) {
      throw new Error(`No se pudo obtener la evidencia ${_error.message}`);
    }
  }
}
